import { useRouter } from "next/router";
import SectionLayout from "../../components/[przyjaznedeklaracje]/_sectionLayout";
import MapaStronyData from "../../variables/variables";
import Section from "../../components/Section";
import TranslatedMessage from "../../components/TranslatedMessage";
import Link from "next/link";

export default function MapaStrony(props) {
  const router = useRouter();

  let Miasto = "PRZYJAZNEDEKLARACJE";
  let Podatek = "mapastrony";

  let propsType;
  let extendedUrl = "/";
  let siteCode = router.query.siteCode;

  if (MapaStronyData.miasta[Miasto].index) {
    propsType = "/";
  } else if (MapaStronyData.miasta[Miasto].witryna) {
    propsType = "/witryna/";
    extendedUrl = "?siteCode=" + siteCode;
  } else {
    propsType = "/" + MapaStronyData.miasta[Miasto].name.url + "/";
  }

  return (
    <SectionLayout
      miasto={Miasto}
      podatek={Podatek}
      typeHero="slider"
      breadcrumbsLayout="light">
      <Section>
        <nav className="pd-sitemap">
          <h2 className="pd-sitemap__title">Strony</h2>
          <ul>
            <li>
              <h3 className="pd-sitemap__subtitle">
                <Link href={propsType}>Strona Główna</Link>
              </h3>
            </li>
            {MapaStronyData.miasta[Miasto].navigation.map((navigation, index) =>
              navigation.submenu.available ? (
                <li key={index}>
                  <h3 className="pd-sitemap__subtitle">
                    <TranslatedMessage id={navigation.translatedMessage} />
                  </h3>

                  <ul>
                    {navigation.submenu.list.map((list, index) => (
                      <li key={index}>
                        {list.submenu ? (
                          <>
                            <h4 className="pd-sitemap__subtitle">
                              <TranslatedMessage id={list.translatedMessage} />
                            </h4>

                            <ul>
                              {list.submenu.map((submenu, index) => (
                                <li key={index}>
                                  <Link
                                    href={
                                      propsType +
                                      submenu.shortName +
                                      extendedUrl
                                    }>
                                    <TranslatedMessage
                                      id={submenu.translatedMessage}
                                    />
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </>
                        ) : (
                          <Link href={propsType + list.shortName + extendedUrl}>
                            <TranslatedMessage id={list.translatedMessage} />
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </li>
              ) : (
                <li key={index}>
                  <h3 className="pd-sitemap__subtitle">
                    <Link href={propsType + navigation.shortName + extendedUrl}>
                      <TranslatedMessage id={navigation.translatedMessage} />
                    </Link>
                  </h3>
                </li>
              )
            )}

            <li>
              <h3 className="pd-sitemap__subtitle">
                <Link href={propsType + "deklaracja-dostepnosci" + extendedUrl}>
                  Deklaracja dostępności
                </Link>
              </h3>
            </li>
          </ul>
        </nav>
      </Section>
    </SectionLayout>
  );
}
